import styled from 'styled-components';

export const DashboardContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: var(--bg-primary);
`;

export const BurgerButton = styled.button<{ $isOpen: boolean }>`
  display: none;
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 101;
  background: var(--accent-orange);
  border: none;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 0;
  box-shadow: var(--shadow-md);
  transition: all 0.2s;

  &:hover {
    background: var(--accent-orange-dark);
    box-shadow: var(--shadow-lg);
  }

  @media (max-width: 768px) {
    display: flex;
  }

  @media (max-width: 1024px) and (orientation: landscape) {
    display: flex;
  }

  span {
    width: 24px;
    height: 3px;
    background: #fff;
    border-radius: 2px;
    transition: all 0.3s;
    transform-origin: center;

    &:nth-child(1) {
      transform: ${props => props.$isOpen ? 'rotate(45deg) translateY(8px)' : 'none'};
    }

    &:nth-child(2) {
      opacity: ${props => props.$isOpen ? 0 : 1};
    }

    &:nth-child(3) {
      transform: ${props => props.$isOpen ? 'rotate(-45deg) translateY(-8px)' : 'none'};
    }
  }
`;

export const SidebarOverlay = styled.div<{ $isOpen: boolean }>`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transition: opacity 0.3s, visibility 0.3s;

  @media (max-width: 768px) {
    display: block;
  }

  @media (max-width: 1024px) and (orientation: landscape) {
    display: block;
  }
`;

export const Sidebar = styled.aside<{ $isOpen: boolean }>`
  width: 320px;
  background: var(--bg-sidebar);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: var(--shadow-lg);
  z-index: 100;
  height: 100vh;
  overflow-y: auto;
  transition: transform 0.3s ease-in-out;

  @media (max-width: 768px) {
    width: 260px;
    transform: ${props => props.$isOpen ? 'translateX(0)' : 'translateX(-100%)'};
  }

  @media (max-width: 1024px) and (orientation: landscape) {
    width: 260px;
    transform: ${props => props.$isOpen ? 'translateX(0)' : 'translateX(-100%)'};
  }
`;

export const SidebarTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.25rem 0 0 0;

  @media (min-width: 769px) {
    padding: 1.75rem 0 0 0;
  }
`;

export const SidebarLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.2rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 900;
  margin-bottom: 0;

  @media (min-width: 769px) {
    font-size: 3rem;
  }
`;

export const SidebarLogoButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.2rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 900;
  margin-bottom: 0;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  outline: none;
  transition: opacity 0.2s;
  box-shadow: none;

  &:hover {
    opacity: 0.85;
  }
  &:focus, &:focus-visible {
    outline: none;
    box-shadow: none;
  }

  @media (min-width: 769px) {
    font-size: 3rem;
  }
`;

export const SidebarLogoSJ = styled.span`
  color: var(--accent-orange);
  font-family: 'Poppins', sans-serif;
  font-weight: 900;
  letter-spacing: -0.05em;
`;

export const SidebarLogoMate = styled.span`
  color: var(--text-dark);
  font-family: 'Poppins', sans-serif;
  font-weight: 900;
  letter-spacing: -0.05em;
`;

export const SidebarTitle = styled.div`
  color: var(--text-gray);
  font-family: 'Poppins', sans-serif;
  font-size: 0.7rem;
  font-weight: 900;
  letter-spacing: 0.12em;
  margin-bottom: 0.05rem;
  margin-top: -0.3rem;
  text-align: center;
`;

export const SidebarDivider = styled.div`
  width: 85%;
  height: 4px;
  background: var(--accent-orange);
  margin: 0.75rem auto 0.6rem auto;

  @media (min-width: 769px) {
    margin: 1.25rem auto 1.25rem auto;
  }
`;

export const NavList = styled.nav<{ $gap?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.$gap || '0.35rem'};
  width: 100%;
  padding: 0;
  margin-top: 0.1rem;
  flex: 1;
  justify-content: flex-start;

  @media (max-width: 1024px) {
    gap: 1rem;
    margin-top: 0.25rem;
  }

  @media (min-width: 769px) {
    gap: 0.85rem;
    margin-top: 0.5rem;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    gap: 1rem;
  }
`;

export const NavSpacer = styled.div`
  flex: 1;
  min-height: 0;
`;

export const AIChatButton = styled.button<{ $active?: boolean; $compact?: boolean }>`
  width: ${props => props.$compact ? '82%' : '90%'};
  background: var(--accent-orange);
  border: none;
  color: #fff;
  font-family: 'Poppins', sans-serif;
  font-size: ${props => props.$compact ? '0.62rem' : '0.72rem'};
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: ${props => props.$compact ? '0.45rem 0.8rem' : '0.5rem 1rem'};
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
  border-radius: ${props => props.$compact ? '6px' : '12px'};
  margin: 0 auto;
  margin-bottom: -0.2rem;
  box-shadow: 0 2px 8px rgba(255, 150, 0, 0.3);
  position: relative;
  flex-shrink: 0;
  min-height: ${props => props.$compact ? '38px' : 'auto'};

  @media (max-width: 768px) {
    margin-top: ${props => props.$compact ? '0.6rem' : '0'};
  }

  @media (min-width: 769px) {
    font-size: ${props => props.$compact ? '0.75rem' : '1rem'};
    padding: ${props => props.$compact ? '0.5rem 1rem' : '0.6rem 1.75rem'};
    border-radius: ${props => props.$compact ? '6px' : '12px'};
    min-height: ${props => props.$compact ? '40px' : '48px'};
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &:hover, &:focus {
    background: var(--accent-orange-dark);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 150, 0, 0.4);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(255, 150, 0, 0.3);
  }

  span {
    filter: brightness(0) invert(1);
    display: inline-block;
  }
`;

export const NavItem = styled.button<{ $active?: boolean; $isFirstItem?: boolean }>`
  width: 90%;
  background: none;
  border: none;
  color: ${props => props.$active ? 'var(--accent-orange)' : 'var(--text-gray)'};
  font-family: 'Poppins', sans-serif;
  font-size: 0.72rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 0.35rem 1.2rem 0.35rem 2.2rem;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
  box-shadow: none;
  position: relative;
  margin: 0 auto;
  flex-shrink: 0;
  margin-top: ${props => props.$isFirstItem ? '1rem' : '0'};

  @media (max-width: 1024px) {
    padding: 0.65rem 1.2rem 0.65rem 2.2rem;
    min-height: 44px;
    display: flex;
    align-items: center;
  }

  @media (min-width: 769px) {
    font-size: 0.8rem;
  }

  @media (min-width: 1025px) {
    padding: 0.45rem 1.2rem 0.45rem 2.2rem;
    min-height: 0;
  }

  &:hover, &:focus {
    color: var(--accent-orange);
    outline: none;
    box-shadow: none;
  }

  &:active {
    outline: none;
    box-shadow: none;
  }

  &::before {
    content: '';
    display: ${props => props.$active ? 'block' : 'none'};
    position: absolute;
    left: 1rem;
    top: 0;
    width: 5px;
    height: 100%;
    background: var(--accent-orange);
  }
`;

export const NavSubItem = styled.button<{ $active?: boolean }>`
  width: 85%;
  background: none;
  border: none;
  color: ${props => props.$active ? 'var(--accent-orange)' : 'var(--text-gray)'};
  font-family: 'Poppins', sans-serif;
  font-size: 0.62rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding: 0.2rem 1.2rem 0.2rem 2.8rem;
  text-align: left;
  cursor: pointer;
  transition: color 0.2s;
  outline: none;
  box-shadow: none;
  position: relative;
  margin: 0 auto;
  margin-bottom: 0.05rem;
  opacity: ${props => props.$active ? 1 : 0.8};
  flex-shrink: 0;

  @media (max-width: 1024px) {
    padding: 0.5rem 1.2rem 0.5rem 2.8rem;
    min-height: 40px;
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
  }

  @media (min-width: 769px) {
    font-size: 0.75rem;
  }

  @media (min-width: 1025px) {
    padding: 0.3rem 1.2rem 0.3rem 2.8rem;
    margin-bottom: 0.05rem;
    min-height: 0;
  }

  &:hover, &:focus {
    color: var(--accent-orange);
    opacity: 1;
    outline: none;
    box-shadow: none;
  }

  &:active {
    outline: none;
    box-shadow: none;
  }

  &::before {
    content: '';
    display: ${props => props.$active ? 'block' : 'none'};
    position: absolute;
    left: 1.8rem;
    top: 0;
    width: 4px;
    height: 100%;
    background: var(--accent-orange);
  }
`;

export const NavSubList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
  width: 100%;
  margin-top: 0;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    gap: 0.4rem;
    margin-top: 0.15rem;
  }
`;

export const SidebarBottom = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  gap: 0.25rem;
  margin-bottom: 1rem;
  margin-top: auto;
  padding: 0 5%;
`;

export const SettingsButton = styled.button`
  flex: 1;
  background: var(--accent-orange);
  border: none;
  color: #fff;
  font-family: 'Poppins', sans-serif;
  font-size: var(--button-font-size, 0.6rem);
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: var(--button-padding, 0.4rem 0.75rem);
  text-align: center;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  outline: none;
  border-radius: 8px;
  white-space: nowrap;

  &:hover, &:focus {
    background: var(--accent-orange-dark);
    color: #fff;
  }
`;

export const LogoutButton = styled.button`
  flex: 1;
  background: #fff;
  border: 2px solid var(--card-border);
  color: #000;
  font-family: 'Poppins', sans-serif;
  font-size: var(--button-font-size, 0.6rem);
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: var(--button-padding, 0.4rem 0.75rem);
  text-align: center;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
  outline: none;
  border-radius: 8px;
  white-space: nowrap;

  &:hover, &:focus {
    background: #f5f5f5;
    border-color: var(--card-border);
    color: #000;
  }
`;

export const SettingsIconButton = styled.button`
  width: auto;
  height: 100%;
  min-width: 40px;
  background: var(--bg-primary);
  border: 2px solid var(--card-border);
  border-radius: 8px;
  color: var(--text-gray);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
  flex-shrink: 0;
  padding: 0.45rem;

  &:hover, &:focus {
    border-color: var(--accent-orange);
    color: var(--accent-orange);
    background: var(--bg-sidebar);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const SidebarFooterLine = styled.div`
  display: none;
`;

/** Mobile-only top header: burger, logo, ?. Hidden on scroll down, shown on scroll up. */
export const MobileDashboardHeader = styled.header<{ $visible: boolean }>`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: var(--bg-primary);
  border-bottom: 1px solid var(--card-border);
  z-index: 98;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  transition: transform 0.25s ease-out;
  transform: translateY(${props => props.$visible ? '0' : '-100%'});
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  @media (max-width: 768px) {
    display: flex;
  }

  @media (max-width: 1024px) and (orientation: landscape) {
    display: flex;
  }
`;

export const MobileHeaderBurger = styled.button`
  width: 44px;
  height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  background: var(--accent-orange);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  align-self: center;

  span {
    width: 22px;
    height: 2.5px;
    background: #fff;
    border-radius: 2px;
    display: block;
  }
`;

export const MobileHeaderLogo = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  font-weight: 900;
  font-size: 1.6rem;
  letter-spacing: -1px;
  padding: 0.25rem 0.5rem;
  align-self: center;
  outline: none;
  box-shadow: none;

  span:first-of-type {
    color: var(--accent-orange);
  }
  span:last-of-type {
    color: var(--text-dark);
  }
  &:focus, &:focus-visible {
    outline: none;
    box-shadow: none;
  }
`;

export const MobileHeaderHelp = styled.a`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--accent-orange);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  align-self: center;

  &:hover {
    background: var(--accent-orange-dark);
    color: #fff;
  }
`;

/** Mobile header: orange "+" button that opens add menu (replaces ? on mobile) */
export const MobileHeaderAddButton = styled.button`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--accent-orange);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 1.25rem;
  font-weight: 700;
  cursor: pointer;
  flex-shrink: 0;
  align-self: center;
  box-shadow: 0 2px 8px rgba(255, 150, 0, 0.3);

  &:hover {
    background: var(--accent-orange-dark);
    color: #fff;
  }
`;

/** Mobile header: add menu dropdown below the + button */
export const MobileHeaderAddMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 200px;
  z-index: 99;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  padding: 0.5rem;
  animation: mobileAddMenuFadeIn 0.2s ease;
  @keyframes mobileAddMenuFadeIn {
    from { opacity: 0; transform: translateY(-4px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const MobileHeaderAddOption = styled.button`
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  background: var(--accent-orange);
  color: #fff;
  border: none;
  font-family: 'Poppins', sans-serif;
  font-size: 0.7rem;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: -0.02em;

  &:hover {
    background: var(--accent-orange-dark);
  }
`;

export const MainContent = styled.main`
  flex: 1;
  margin-left: 320px;
  padding: 3.5rem 3.5rem 2.5rem 3.5rem;
  overflow-y: auto;
  background: var(--bg-primary);
  position: relative;
  min-height: 100vh;

  @media (max-width: 768px) {
    margin-left: 0;
    padding: 1rem;
    padding-top: 4.5rem;
  }

  @media (max-width: 1024px) and (orientation: landscape) {
    margin-left: 0;
    padding: 1rem;
    padding-top: 4.5rem;
  }
`;

export const PageTitle = styled.h1`
  font-size: 2.1rem;
  color: var(--accent-orange);
  font-family: 'Poppins', sans-serif;
  font-weight: 900;
  margin-bottom: 0.3rem;
  text-align: left;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: var(--mobile-headline, 1.5rem);
  }
`;